import React, { memo, forwardRef } from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

export const ChannelYoutubeIcon = memo(
  forwardRef((props, ref) => {
    return (
      <SvgIcon
        {...props}
        ref={ref}
        viewBox="0 0 16 16"
      >
        <path
          d="M7.99503 2.40112C7.99503 2.40112 2.99438 2.40113 1.73929 2.72726C1.06726 2.91503 0.513906 3.46839 0.326135 4.1503C7.43046e-06 5.4054 0 8.0046 0 8.0046C0 8.0046 7.43046e-06 10.6137 0.326135 11.849C0.513906 12.5309 1.05738 13.0744 1.73929 13.2622C3.00426 13.5982 7.99503 13.5982 7.99503 13.5982C7.99503 13.5982 13.0056 13.5982 14.2607 13.2721C14.9426 13.0843 15.486 12.5507 15.6639 11.8589C15.9999 10.6137 15.9999 8.01449 15.9999 8.01449C15.9999 8.01449 16.0098 5.4054 15.6639 4.1503C15.486 3.46839 14.9426 2.92492 14.2607 2.74703C13.0056 2.40114 7.99503 2.40112 7.99503 2.40112ZM6.4039 5.60316L10.5646 8.0046L6.4039 10.3962V5.60316Z"
          fill="#F7F9FD"
        />
      </SvgIcon>
    );
  })
);
